import React from "react";
import styled from "styled-components";
import { ReactComponent as LoadingIcon } from "../assets/spinner-regular.svg";
import PropTypes from "prop-types";

const SpinnerIcon = ({ width, height, color }) => (
    <StyledSpinnerWrapper $width={width} $height={height} $color={color}>
        <LoadingIcon />
    </StyledSpinnerWrapper>
);

SpinnerIcon.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
};

SpinnerIcon.defaultProps = {
    width: "1.5em",
    height: "1.5em",
};

export default SpinnerIcon;

/* Styled Components */

const StyledSpinnerWrapper = styled.div`
    color: ${(props) => (props.$color ? props.$color : "inherit")};
    width: ${(props) => props.$width};
    height: ${(props) => props.$height};
    line-height: 0;
    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    animation-name: spin;
    animation-duration: 2000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
`;
